import { useRef } from 'react'

interface ScrollTo {
  scrollRef: React.RefObject<HTMLElement>
  scrollToRef: () => void
}

export const useScrollTo = (): ScrollTo => {
  const scrollRef = useRef<HTMLElement>(null)

  const scrollToRef = () => {
    if (scrollRef.current) scrollRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  return { scrollRef, scrollToRef }
}
